module.exports = __webpack_public_path__ + "img/intro_min.cac76f88.webp";